import { PRIMARY_BLUE } from "./colors";

export const PRIMARY_BG_GRADIENT = `linear-gradient(180deg, ${PRIMARY_BLUE} 0%, ${PRIMARY_BLUE} 100%)`;
export const INVITE_BG_GRADIENT = `linear-gradient(
  180deg,
  rgba(255, 255, 255, 0.08) 78.25%,
  rgba(20, 83, 245, 0.5) 122.4%
)`;
export const BOX_SHADOW =
  "0px 2px 8px rgba(0, 0, 0, 0.06), 0px 16px 64px -12px rgba(0, 0, 0, 0.1);";
